import {SupportedLanguage} from '~/utils/locales'
import {WebsitePath} from '~/utils/routes'
import {AppPath} from '~/utils/routes.app'
import {SupportPath} from '~/utils/routes.support'

export type LanguageCombination = {source: SupportedLanguage; target: SupportedLanguage}

export const LANGUAGES_SHOWCASE_COMBINATIONS: LanguageCombination[] = [
  {source: 'en', target: 'it'},
  {source: 'fr', target: 'en'},
  {source: 'en', target: 'ja'},
  {source: 'it', target: 'en'},
  {source: 'en', target: 'de'},
  {source: 'it', target: 'de'}
]

export type FooterLink = {
  label: string
} & (
  | {type: 'internal'; url: AppPath; isAppUrl: true}
  | {type: 'internal'; url: WebsitePath; isAppUrl?: false}
  | {type: 'external'; url: string}
  | {type: 'support'; url?: SupportPath}
)

type FooterSection = {title: string; links: FooterLink[]}

export const FOOTER_SECTIONS: FooterSection[] = [
  {
    title: 'footer.company',
    links: [
      {type: 'internal', label: 'footer.about_lara', url: '/about-lara'},
      {type: 'support', label: 'footer.whats_new', url: '/whats-new'},
      {type: 'internal', label: 'footer.contact_sales', url: '/sales'},
      {
        type: 'external',
        label: 'footer.contact_support',
        url: 'mailto:support@laratranslated.com?subject=Support%20request'
      },
      {type: 'support', label: 'footer.media_kit', url: '/media-kit'}
    ]
  },
  {
    title: 'footer.features',
    links: [
      {type: 'internal', label: 'footer.translate_text', url: '/translate'},
      {
        type: 'internal',
        label: 'footer.translate_documents',
        url: '/translate/documents',
        isAppUrl: true
      },
      {
        type: 'internal',
        label: 'footer.interpreter',
        url: '/translate/interpreter',
        isAppUrl: true
      }
    ]
  },
  {
    title: 'footer.resources',
    links: [
      {type: 'external', label: 'footer.blog', url: 'https://blog.laratranslate.com/'},
      {type: 'support', label: 'footer.knowledge_base'},
      {type: 'support', label: 'footer.integrations', url: '/api-and-integrations'},
      {
        type: 'external',
        label: 'footer.developers_hub',
        url: 'https://developers.laratranslate.com/'
      },
      {
        type: 'external',
        label: 'footer.status_page',
        url: 'https://status.laratranslate.com/'
      }
    ]
  },
  {
    title: 'footer.legal',
    links: [
      {type: 'internal', label: 'footer.privacy_policy', url: '/privacy-policy'},
      {type: 'internal', label: 'footer.terms_and_conditions', url: '/terms-and-conditions'}
    ]
  }
]
